module.exports = __webpack_public_path__ + "static/assets/cf9032414f074bba669aa72de0db7be6.svg";